import { createAction } from 'typesafe-actions';

import modalActionTypes from './actionTypes';
import { ModalAction } from './initialState';

export const actionShowModal = createAction(modalActionTypes.SHOW_MODAL, (data: ModalAction) => data)<ModalAction>();
export const actionSubmitModal = createAction(modalActionTypes.SUBMIT_MODAL)<void>();
export const actionCloseModal = createAction(modalActionTypes.CLOSE_MODAL)<void>();
export const actionUpdateModal = createAction(modalActionTypes.UPDATE_MODAL, (update: ModalAction) => update)<ModalAction>();
